import Int32LookupResourceModel from '../../generated/types/model/resource/Int32LookupResourceModel';

export default class Int32LookupResourceViewModel extends Int32LookupResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
